<template>
  <div class="kp-flat-card small-shadow dark primary-bg top-products p-20">
    <div class="row mb-20">
      <div class="col-sm-6 d-flex align-items-center">
        <h6 class="mb-0">Top Products</h6>
      </div>
      <div class="col-sm-6 d-flex align-items-center justify-content-end">
        <a href="#" class="read-more">view all</a>
      </div>
    </div>
    <div class="table-list">
      <div class="tl-li" v-for="(product, index) in topProducts" :key="index">
        <div class="row">
          <div class="col name">{{ product.name }}</div>
          <div class="col amount">{{ product.amount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'top-products',
  data() {
    return {
      topProducts: [
        { name: 'Risk Management', amount: 254 },
        { name: 'Fraud Prevention', amount: 241 },
        { name: 'Cyber Security', amount: 187 },
      ]
    }
  }
}
</script>
